import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCancelCloseOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.34043 17.65C6.14043 17.45 6.14043 17.14 6.34043 16.94L16.9404 6.34C17.1404 6.14 17.4504 6.14 17.6504 6.34C17.8504 6.54 17.8504 6.85 17.6504 7.05L7.04043 17.65C6.85043 17.85 6.53043 17.85 6.34043 17.65Z",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.34043 6.34C6.54043 6.14 6.85043 6.14 7.05043 6.34L17.6604 16.95C17.8604 17.15 17.8604 17.46 17.6604 17.66C17.4604 17.86 17.1504 17.86 16.9504 17.66L6.34043 7.04C6.14043 6.85 6.14043 6.53 6.34043 6.34Z",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCancelCloseOutline;
